import { Col, Container, Row } from 'reactstrap';
import InnerBanner from '../../components/InnerBanner';
import SEO from '../../components/SEO';
import OurEdge from './components/OurEdge';
import OurStory from './components/OurStory';

const AboutUs = () => {
  return (
    <>
      <SEO title="About Us" />

      <div className="resource">
        <InnerBanner
          title="About Us"
          description="Empowering Clients Through Smart Legal Solutions Built on Integrity, Technology, and Excellence.
We believe in transforming legal challenges into opportunities through intelligent, transparent, and tech-enabled practices."
        />

        <section className="position-relative about-source">
          {/* <LineMask /> */}
          <section className="section-gap-lg pb-0">
            <Container>
              <div className="about-legalligence">
                <h2>Our Story</h2>
                <p data-aos="fade-up" className="head-gap-lg">
                  At Legalligence, we started with a simple but powerful idea: What if legal
                  processes could be smarter, faster, and more accessible-without compromising on
                  accuracy or insight?
                </p>
                <p data-aos="fade-up">
                  Founded by a passionate team of technologists and supported by a strong network of
                  seasoned legal professionals, Legalligence brings together the best of both
                  worlds: cutting-edge artificial intelligence and deep legal expertise. We
                  recognized a widespread challenge—legal work is often slowed down by manual,
                  repetitive tasks that consume valuable time and resources. Whether it’s a law firm
                  managing complex caseloads, a corporate legal department navigating compliance, or
                  an individual seeking clarity on legal rights, the need for efficient, intelligent
                  solutions is universal.
                </p>
              </div>
            </Container>
          </section>
          <OurStory />
          <OurEdge />
          {/* <OurCore /> */}
          {/* <Testimonial />
          <TeamSection /> */}
          {/* <SourceMask /> */}
        </section>
      </div>
    </>
  );
};

export default AboutUs;
